import logo from "modules/development/assets/images/rubk-logo.svg";
import * as React from "react";
import { Grid, CssBaseline, Button, withStyles } from "@material-ui/core";
import LoginAuth from "modules/login/components/layouts/LoginAuth";
import Register from "modules/login/components/layouts/Register";
import { RouteComponentProps } from "react-router";
import { observer } from "mobx-react";
import { LoginStore } from "modules/login/LoginStore";
import i18n from "i18n";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#000000,5%",
  },
  header: {
    backgroundColor: "#333",
    width: "100%",
    height: 64,
    padding: "20px 24px",
  },
  alingButtons: {
    backgroundColor: "#333",
    width: "100%",
    height: 64,
    padding: "20px 24px",
    alignItems: "center",
    justifyContent: "flex-end",
    display: "flex",
  },
  topBtn: {
    color: "#9AAF00",
    marginLeft: "15px",
    marginRight: "15px",
    border: "solid 1px #fafafa",
    "&:hover": {
      backgroundColor: "#fafafa",
    },
  },
});

type IProps = {
  classes: any;
};
interface IStates {
  isAuthenticating: boolean;
  page: string;
}

@observer
class Login extends React.Component<
  IProps & RouteComponentProps<IProps>,
  IStates
> {
  constructor(props) {
    super(props);
    this.handler = this.handler.bind(this);
    let path = location.pathname.replace(/\//g, "");
    this.state = {
      isAuthenticating: true,
      page: path ? path.toLowerCase() : "login",
    };
    this._auth();
  }

  /**
   * Auth listener
   */
  _auth = async () => {
    let { history } = this.props;

    this.setState({ isAuthenticating: true });

    const user = await LoginStore.addListenerToVerifySession();
    if (user && LoginStore.isUserAuth) {
      history.push("/menu/development");
    } else {
      this.setState({
        isAuthenticating: false,
      });
    }
  };

  handler(e) {
    e.preventDefault();
    this.setState({
      page: this.state.page == "Login" ? "Register" : "Login",
    });
  }

  render() {
    const { classes } = this.props;
    const { page } = this.state;

    return (
      <div>
        {!this.state.isAuthenticating ? (
          <React.Fragment>
            <CssBaseline />
            <Grid container>
              <Grid container>
                <Grid item xs={6}>
                  <div className={classes.header}>
                    <img style={{ height: "21px" }} src={logo} />
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className={classes.alingButtons}>
                    {page == "register" && (
                      <Button
                        href="/login"
                        variant="outlined"
                        className={classes.topBtn}
                        style={{ border: "none" }}
                      >
                        {i18n.trialRegister.enter}
                      </Button>
                    )}
                    {page == "login" && (
                      <Button
                        href="/register"
                        variant="outlined"
                        className={classes.topBtn}
                      >
                        {i18n.trialRegister.freeTrial}
                      </Button>
                    )}
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.root}>
                  {page == "login" ? (
                    <LoginAuth {...this.props}></LoginAuth>
                  ) : (
                    <Register {...this.props}></Register>
                  )}
                </div>
              </Grid>
            </Grid>
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/modules/login/components/pages/Login.tsx